import { GridColumnType } from "../../../components/FinalMolGrid/libs/data/gridColumnType";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

const initState = {
  eventname: null,
  status: null,
  hidden: null,
};


export const EventListFilterFormData = {

  name: "EventListFilterFormData",
  initialState: initState,
  section: [
    {
      title: "EventListFilterFormData",
      row: {},
      style: {
        sectionStyle: "row verticle-form",
      },
      rowGroup: [
        {
          groupLabel: "EventListFilterFormData", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="row"></div>, // Wrapper HTML or Component
          fields: [
            {
              id: "eventName",
              label: "Search by Event Name",
              Field_Name: "Search by Event Name",
              fieldType: FormFieldTypes.INPUT,
              dataField: "eventName",
              fieldSetting: {
                allowSpace: false,
              },
              //  validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-4 mb-2 validation-left-0 mb-2",
              },
            },
            {
              id: "status",
              label: "Status",
              Field_Name: "Status",
              fieldType: FormFieldTypes.SELECT,
              dataField: "status",
              fieldSetting: {
                placeholder: "Select",
                options: [
                  // { value: 1, label: 'Draft' },
                  // { value: 2, label: 'Submitted' },
                  // { value: 12, label: 'Approved' },
                ],
              },
              // validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-4 mb-2 validation-left-0 mb-2",
              },
            },
            {
              id: "hidden",
              label: "Hidden",
              Field_Name: "Hidden",
              fieldType: FormFieldTypes.SELECT,
              dataField: "hidden",
              fieldSetting: {
                placeholder: "Select",
                options: [
                  { value: 1, label: "Yes" },
                  { value: 2, label: "No" },
                ],
              },
              // validation: [{ type: validationTypes.REQUIRE }],
              style: {
                containerCss: "col-lg-4 mb-2 validation-left-0 mb-2",
              },
            },
          ],
        },
      ],
    },
  ],
}
export const eventListTableConfig = {
  columns: [
    {
      name: "Event Name",
      fieldName: "eventName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Event Date",
      fieldName: "eventDate",
      allowShort: false,
      colType: GridColumnType.DATE,
      colSettings: {
        format: 'DD-MMM-YYYY',
      }
    },
    {
      name: "Type",
      fieldName: "eventTypeName",
      colType: GridColumnType.Text,
    },
    {
      name: "Hidden",
      fieldName: "isHidden",
      colType: GridColumnType.Text,
    },
    {
      name: "Booking",
      fieldName: "booking",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      customWrapper: [
        {
          name: "Cancel",
          label: "Cancel",
        },
        {
          name: "Download",
          label: "Download",
        },
        {
          name: "URLLink",
          label: "URLLink",
        }
      ],
    },
  ],
};